<!-- 优惠卡券 -->
<template>
  <div class="shareCode" v-cloak>
    <van-nav-bar :border="false" left-arrow fixed :title="document.title" class="shareCode_nav_bar" @click-left="onClickLeft" :z-index="20" :style="'background: #FF7512; color:#FFFFFF;'"></van-nav-bar>

    <div class="top-user">

      <div class="user-img">
        <img :src="userInfo.head_photo" alt="">
      </div>
      <div class="user-name">
        <p>我是<span>{{ userInfo.user_nickname }}</span></p>
        <p>我为百分百代言</p>
      </div>

    </div>
    <div class="center-tips">
      与好友一起纵享好物！
      <!-- 零成本投入，分享轻松赚佣金，体验 <br>消费致富 -->
    </div>
    <!-- <p class="center-b" v-html="document.user_qr"></p> -->

    <div class="user_qr" >
        <img :src="document.user_qr" alt="">
        <p>扫一扫，识别图中二维码</p>
    </div>
   

  </div>
</template>
  
  <script type="text/babel">
import wx from "weixin-js-sdk";
export default {
  name: "mine-shareCode",
  components: {},
  props: {},
  data() {
    return {
      userInfo: {},
      document: {
        title: "我的二维码",
        user_qr: undefined,
      },
    };
  },
  watch: {},
  created() {},
  mounted() {
    // this.$toast.loading();
    this.getInit();

    this.getUser();
  },
  methods: {
    getUser() {
      this.userInfo = Lockr.get("userInfo") || this.$store.getters.userInfo; //用户信息
    },
    getInit() {
      let _this = this;
      _this.$post("/api/user_qr").then((res) => {
        console.log(res.data, "我的二维码");
        // this.$toast.clear();
        if (res.data && res.data.code == 0) {
          this.document.user_qr = res.data.data.qr;
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },

    formatRichText(html) {
      /*
       * 处理富文本里的图片宽度自适应
       * 1.去掉img标签里的style、width、height属性
       * 2.img标签添加style属性：max-width:100%;height:auto
       * 3.修改所有style里的width属性为max-width:100%
       * 4.去掉<br/>标签
       * @param html
       * @returns {void|string|*}
       */
      let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
        match = match
          .replace(/style="[^"]+"/gi, "")
          .replace(/style='[^']+'/gi, "");
        match = match
          .replace(/width="[^"]+"/gi, "")
          .replace(/width='[^']+'/gi, "");
        match = match
          .replace(/height="[^"]+"/gi, "")
          .replace(/height='[^']+'/gi, "");
        // match = match
        //   .replace(/src="([^"]+)"/gi, 'src="http://xiche.yiro.top$1"')
        //   .replace(/src='([^']+)'/gi, 'src="http://xiche.yiro.top$1"');
        return match;
      });
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/width:[^;]+;/gi, "max-width:100%;")
            .replace(/width:[^;]+;/gi, "max-width:100%;");
          return match;
        }
      );
      // newContent = newContent.replace(/<br[^>]*\/>/gi, '');
      newContent = newContent.replace(
        /\<img/gi,
        '<img style="max-width:100%;height:auto;display:inline-block;"'
      );

      //去除table的宽度
      newContent = newContent.replace(
        /<table[^>]*>/gi,
        function (match, capture) {
          return match.replace(/width=\"(.*)\"/gi, "");
        }
      );

      //去除text-indent
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/text-indent:[^;]+;/gi, "text-indent:0")
            .replace(/text-indent:[^;]+;/gi, "text-indent:0");
          return match;
        }
      );

      return newContent;

      //
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>
  
  <style lang="scss">
.shareCode_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
}
.shareCode {
  // 空状态
  .custom-image .van-empty__image {
    width: 260px;
    height: 300px;
  }
}
</style>
  
  <style lang="scss" scoped>
.shareCode {
  height: 100%;
  width: 100%;
  padding: 50px 0;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  background-image: url("../../assets/public/fx_bg.png");
  background-repeat: no-repeat;
  background-position: 0 45px;
  background-size: 100% 100%;
  position: relative;

  .header-video {
    margin: 15px;
    padding: 10px;
    background: #ffffff;
    border-radius: 10px;
    .video {
      height: 182px;
      width: 100%;
      video {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }

  .list-tips {
    font-size: 32px;
    font-family: YouSheBiaoTiHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 24px;
    text-shadow: 1px 2px 0px #0f52de;

    text-align: left;
    padding: 10px 15px 0;
  }
}

.center-b {
  padding: 15px;
  font-size: 13px;
  text-align: left;
  p {
    text-indent: 2em;
  }
  img {
    display: block;
    width: 100%;
  }
}

.top-user {
  width: 100%;
  padding: 10px 20px;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  .user-img {
    width: 70px;
    height: 70px;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .user-name {
    text-align: left;
    margin-left: 10px;
    color: #ffffff;
    font-size: 14px;
    line-height: 1.5em;
    margin-top: 5px;
    span {
      color: yellow;
    }
  }
}
.center-tips {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  color: #ffffff;
  font-size: 14px;
  line-height: 1.5em;
}

.user_qr { 
  width: 100%;
  height: 180px;
  position: absolute;
  top: 61%;
  left: 0;
  color: #ffffff;
  font-size: 14px;
  img {
    display: block;
    margin: 0 auto;
    width: 150px;
    height:150px;
    margin-bottom: 10px;
  }
}
// .foot-qrCode {
//   margin: 15px;
//   padding: 10px;
//   //   background-color: #fff;

//   display: flex;
//   justify-content: space-around;
//   align-items: center;

//   .qrCode {
//     width: 70px;
//     height: 100%;
//     img {
//       display: block;
//       width: 100%;
//       height: 70px;
//     }
//   }
//   .addss {
//     text-align: left;
//     font-size: 13px;
//     font-family: Source Han Sans CN;
//     font-weight: 400;
//     // color: #333333;
//     color: #ffffff;
//     line-height: 24px;
//   }
// }
.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
.table {
  width: 100%;

  td div {
    width: 75px;
  }
}
</style>
  